
export const Tick = ({color}) => (
  <svg
    viewBox="0 0 10 7"
    fill="none"
    width="10px"
    height="10px"
    color={color}
  >
    <path d={"M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z"} 
    fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
  </svg>
);
